import { render, staticRenderFns } from "./CookieSettings.vue?vue&type=template&id=a522de08&scoped=true&"
import script from "./CookieSettings.vue?vue&type=script&lang=ts&"
export * from "./CookieSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CookieSettings.vue?vue&type=style&index=0&id=a522de08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a522de08",
  null
  
)

export default component.exports